
import { FileCategory } from 'tessa/files';

export class ChFileCategories {

  static Approval =
    new FileCategory("4deb9ef5-061f-447b-af10-85330ac6374c", "1. Согласуемые");

  static Primary =
    new FileCategory("316a2102-c5f2-4253-aa01-5afaa07d899a", "1. Основные");

  static DevelopmentScenario =
    new FileCategory("fa50199e-6546-4567-8799-f219008b7c11", "1. Девелоперский сценарий");

  static RequestForMaterials =
    new FileCategory("4be335aa-bd65-41d1-ae43-51b070aa8a83", "1. Заявка");

  static DssCertificates =
    new FileCategory("8f3be430-ff25-4081-bcb9-4bb1b92bce68", "1. Сертификаты DSS");

  static PkTCOfferUnsigned =
    new FileCategory("72fff7a4-8960-43f6-b858-96ac5c7ad32a", "1. ТКП без подписи");

  static NepCertificates =
      new FileCategory("5400711e-a9f8-45de-a0b5-1221efa13314", "2. Сертификаты НЭП");

  static AdditionalMaterials =
    new FileCategory("d76c2d4b-fe8e-43b8-934f-57bffa80fd0d", "2. Дополнительные материалы");

  static Informational =
    new FileCategory("9cca8704-b63c-445f-a262-d705b7150649", "2. Информационные");

  static DocumentID =
    new FileCategory("486c5b50-5bc3-4849-acc9-ba9628b5271f", "1. Документ ИД");

  static Journal =
    new FileCategory("af292517-0814-423b-bfd0-f186978f27a3", "2. Журналы");
  
  static PkTCOfferWorkSchedule =
    new FileCategory("a44c5f04-fff9-4bfc-8a1c-a43b39242cab", "2. График работ");

  static ImplementingSchemes =
    new FileCategory("33851601-e99b-41db-9c70-639efb9be8f6", "3. Исполнительные схемы");

  static PkTCOfferSigned =
    new FileCategory("e0398295-e405-4e22-9dec-f651b6d47fc4", "3. ТКП с подписью"); 

  static LaboratoryTests =
    new FileCategory("21394ee3-0d65-4d61-b4f0-47d963fb39aa", "4. Лабораторные испытания");

  static PkTCOfferUnsignedIrrelevant =
    new FileCategory("0172c4a0-4e5c-4e22-9aa6-4da03a911c4c", "4. Неактуальные ТКП без подписи");

  static TechnicalConclusions =
    new FileCategory("5de0e396-b443-449c-8f35-7d2d2da3c733", "5. Технические заключения");

  static PkTCOfferWorkScheduleIrrelevant =
    new FileCategory("3f6601e2-3043-4252-ae0b-315335784283", "5. Неактуальные графики работ");

  static PassportsAndCertificates =
    new FileCategory("e8f84002-4247-4882-9e9f-59b49f0fd4e3", "6. Паспорта и сертификаты");

  static PkTCOfferOther =
    new FileCategory("65dfd107-6605-46a8-a2cd-21476cffef37", "6. Прочие файлы");

  static OtherApplications =
    new FileCategory("7a2df5b3-8346-44a5-9a83-4bf28ec3c3b4", "7. Прочие приложения");

  static ElectronicSignatures =
    new FileCategory("7f02bc47-b78a-4e65-9de9-4a387d05f4b8", "8. Электронные подписи");

  static Revocation =
    new FileCategory("f14f212c-9950-46c8-a789-db420207fd04", "10. Аннулирование");

  static AdditionalForContract =
    new FileCategory("9ecd7b45-6d99-4db4-978d-5560984d9b05", "3. Приложения");

  static ANPT =
    new FileCategory("a7f9b975-5963-40cd-b745-4ceec2acc5ec", "АНПТ");

  static PrintForms =
    new FileCategory("eb36d3fe-93fa-46a4-b4f7-362a7827df51", "5. Печатные формы");

  static FullPacket =
    new FileCategory("855a80e1-a831-4405-a7a8-5770c5978c78", "6. Полный пакет");



  static FileCategories =
    [
      ChFileCategories.Primary,
      ChFileCategories.Informational,
      ChFileCategories.DocumentID,
      ChFileCategories.Journal,
      ChFileCategories.ImplementingSchemes,
      ChFileCategories.LaboratoryTests,
      ChFileCategories.PassportsAndCertificates,
      ChFileCategories.OtherApplications,
      ChFileCategories.ElectronicSignatures,
      ChFileCategories.TechnicalConclusions,
      ChFileCategories.DevelopmentScenario,
      ChFileCategories.AdditionalMaterials,
      ChFileCategories.RequestForMaterials,
      ChFileCategories.ANPT
    ];
}